import React, { type ComponentProps } from 'react';

import {
  Modal as BlueprintModal,
  ModalBody,
  ModalClose,
  ModalContent,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalPortal,
  ModalTitle,
  ModalTrigger,
} from '@buildoutinc/blueprint-react/ui/Modal';

interface Props extends ComponentProps<typeof BlueprintModal> {
  onClose?: () => void;
}

function ModalRoot({ onClose, onOpenChange, ...rest }: Props) {
  return (
    <BlueprintModal
      {...rest}
      onOpenChange={(open, eventDetails) => {
        onOpenChange?.(open, eventDetails);

        if (!open) {
          onClose?.();
        }
      }}
    />
  );
}

export const Modal = Object.assign(ModalRoot, {
  Body: ModalBody,
  Close: ModalClose,
  Content: ModalContent,
  Description: ModalDescription,
  Footer: ModalFooter,
  Header: ModalHeader,
  Portal: ModalPortal,
  Title: ModalTitle,
  Trigger: ModalTrigger,
});
